import type { TMessages } from '@/types/TMessages'

export const messages = {
  comment: 'Заявка на консультацию с главной страницы',
} as const satisfies TMessages
